.container
    br
    .text-center
        h1 We're sorry to see you go.
        p If there's anything we can do to help, email us at&nbsp;
            a(href="mailto:support@appcues.com") support@appcues.com.
